import { routes } from "~/app/routes/web-routes.ts";
import { Role } from "~/shared/constants/roles.ts";

export const ACCOUNT_SETTINGS_ROLES: ReadonlySet<string> = new Set([
	Role.Admin,
	Role.Operations,
	Role.Finance,
]);
export const REPORTS_ROLES: ReadonlySet<string> = new Set([
	Role.Admin,
	Role.Operations,
	Role.Reporting,
]);
// Roles allowed to view and CRUD Vendor Management as an external user.
// Internal users bypass this set; vendors are denied by `VendorAccessGuard`.
export const VENDOR_MANAGEMENT_ROLES: ReadonlySet<string> = new Set([
	Role.Admin,
	Role.Operations,
]);

// path list whitelisted for vendors
export const VENDOR_ALLOWED_ROUTE_PREFIXES: readonly string[] = [
	routes.mySettings,
	routes.ltlShipment,
	routes.tender,
	routes.authCallback,
	routes.feedback,
];

// Paths explicitly denied to vendors even when they fall under an allowed
// prefix. Carrier Selection lives beneath the allowed `/ltl-shipment` prefix,
// but vendors must never reach it — they tender directly from /ltl-shipment and
// are handed off to their LTL Account Representative instead.
export const VENDOR_BLOCKED_ROUTE_PREFIXES: readonly string[] = [
	routes.ltlShipmentCarrierSelection.replace("/:quoteId", ""),
];

// Vendors land on the LTL Tender page after login.
export const VENDOR_LANDING_ROUTE: string = routes.ltlShipment;
